import React, { useState } from "react";
import { galleryItem } from "./types";
// @ts-ignore
import BackgroundImageOnLoad from "background-image-on-load";

interface GalleryThumbnailsProps {
  gallery: galleryItem[];
  page: number;
  thumbnailsPerPage: number;
  selectedImage: number;
  setTransitionType: Function;
  changeSelectedImage: Function;
}

interface GalleryItemsProps {
  item: galleryItem;
  page: number;
  thumbnailsPerPage: number;
  selectedImage: number;
  setTransitionType: Function;
  changeSelectedImage: Function;
  index: number;
}

const GalleryItem = (props: GalleryItemsProps) => {
  const {
    item,
    page,
    thumbnailsPerPage,
    selectedImage,
    setTransitionType,
    changeSelectedImage,
    index
  } = props;

  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="slide" key={index}>
      <a
        href="#0"
        title={item.headline}
        className={`
          ${
            index + page * thumbnailsPerPage === selectedImage && isLoaded
              ? "selected"
              : ""
          } ${isLoaded ? "" : "unloaded"}`}
        onClick={e => {
          if (e) {
            e.preventDefault();
          }
          setTransitionType("fade");
          changeSelectedImage(index + page * thumbnailsPerPage);
        }}
      >
        <span
          style={{
            backgroundImage: `url("${item.thumbnailUrl}")`,
            display: `${!isLoaded ? "none" : "block"}`
          }}
        />
        <BackgroundImageOnLoad
          src={item.thumbnailUrl}
          onLoadBg={() => {
            console.log("loaded" + item.thumbnailUrl);
            setIsLoaded(true);
          }}
        />
        <span
          className="slide__loading-image"
          style={{
            display: `${isLoaded ? "none" : "block"}`
          }}
        />
      </a>
    </div>
  );
};

const GalleryThumbnails = (props: GalleryThumbnailsProps) => {
  const {
    page,
    thumbnailsPerPage,
    gallery,
    selectedImage,
    setTransitionType,
    changeSelectedImage
  } = props;

  return (
    <div key={page} className="gallery__slides">
      {gallery
        .slice(page * thumbnailsPerPage, (page + 1) * thumbnailsPerPage)
        .map((item, index) => {
          return (
            <GalleryItem
              selectedImage={selectedImage}
              setTransitionType={setTransitionType}
              changeSelectedImage={changeSelectedImage}
              item={item}
              index={index}
              page={page}
              thumbnailsPerPage={thumbnailsPerPage}
              key={index}
            />
          );
        })}
    </div>
  );
};

export default GalleryThumbnails;
